import React from 'react'
import styled from 'styled-components'
import moment from 'moment'

import RemoveIcon from 'components/Svg/remove.component.svg'
import DatePicker from 'components/DatePicker'

import { Messages } from 'validations'

const onChange = (event, cb) => {
  const re = /^[0-9\b,]+$/
  if (event.target.value && !re.test(event.target.value)) {
    return false
  }

  cb()
}

const getMinHeight = (consumptionDisaggregation) => {
  if (consumptionDisaggregation === 'vcp') {
    return '30'
  } else if (consumptionDisaggregation === 'vscp') {
    return '45'
  }
  return false
}

const renderExtraInputs = ({ consumptionDisaggregation, invalid, ...rest }) => {
  switch (consumptionDisaggregation) {
    case 's':
      return (
        <InputWrapper>
          <Label>
            Consumo Simples <Lower>(kWh)</Lower>
          </Label>
          <InputDate
            type={`text`}
            value={rest.simples}
            onChange={(e) =>
              onChange(e, () => rest.onChange({ simples: e.target.value }))
            }
            className={invalid && invalid.simples && `invalid`}
          />
          {invalid && invalid.simples && (
            <Error>
              {Messages[invalid.simples] &&
                Messages[invalid.simples](`Simples`)}
            </Error>
          )}
        </InputWrapper>
      )
    case 'vf':
      return (
        <Multi>
          <InputWrapper>
            <Label>
              Consumo Vazio <Lower>(kWh)</Lower>
            </Label>
            <InputDate
              type={`text`}
              value={rest.simples}
              onChange={(e) =>
                onChange(e, () => rest.onChange({ simples: e.target.value }))
              }
              className={invalid && invalid.simples && `invalid`}
            />
            {invalid && invalid.simples && (
              <Error>
                {Messages[invalid.simples] &&
                  Messages[invalid.simples](`Vazio`)}
              </Error>
            )}
          </InputWrapper>
          <InputWrapper>
            <Label>
              Consumo Fora de Vazio <Lower>(kWh)</Lower>
            </Label>
            <InputDate
              type={`text`}
              value={rest.cheias}
              onChange={(e) =>
                onChange(e, () => rest.onChange({ cheias: e.target.value }))
              }
              className={invalid && invalid.cheias && `invalid`}
            />
            {invalid && invalid.cheias && (
              <Error>
                {Messages[invalid.cheias] && Messages[invalid.cheias](`Cheias`)}
              </Error>
            )}
          </InputWrapper>
        </Multi>
      )
    case 'vcp':
      return (
        <Multi>
          <InputWrapper>
            <Label minHeight={`30`}>
              Consumo Vazio <Lower>(kWh)</Lower>
            </Label>
            <InputDate
              type={`text`}
              value={rest.simples}
              onChange={(e) =>
                onChange(e, () => rest.onChange({ simples: e.target.value }))
              }
              className={invalid && invalid.simples && `invalid`}
            />
            {invalid && invalid.simples && (
              <Error>
                {Messages[invalid.simples] &&
                  Messages[invalid.simples](`Vazio`)}
              </Error>
            )}
          </InputWrapper>
          <InputWrapper>
            <Label minHeight={`30`}>
              Consumo Cheias <Lower>(kWh)</Lower>
            </Label>
            <InputDate
              type={`text`}
              value={rest.cheias}
              onChange={(e) =>
                onChange(e, () => rest.onChange({ cheias: e.target.value }))
              }
              className={invalid && invalid.cheias && `invalid`}
            />
            {invalid && invalid.cheias && (
              <Error>
                {Messages[invalid.cheias] && Messages[invalid.cheias](`Cheias`)}
              </Error>
            )}
          </InputWrapper>
          <InputWrapper>
            <Label minHeight={`30`}>
              Consumo Ponta <Lower>(kWh)</Lower>
            </Label>
            <InputDate
              type={`text`}
              value={rest.ponta}
              onChange={(e) =>
                onChange(e, () => rest.onChange({ ponta: e.target.value }))
              }
              className={invalid && invalid.ponta && `invalid`}
            />
            {invalid && invalid.ponta && (
              <Error>
                {Messages[invalid.ponta] && Messages[invalid.ponta](`Cheias`)}
              </Error>
            )}
          </InputWrapper>
        </Multi>
      )
    case 'vscp':
      return (
        <Multi>
          <InputWrapper flex={0.125}>
            <Label minHeight={`45`}>
              Consumo Vazio <Lower>(kWh)</Lower>
            </Label>
            <InputDate
              type={`text`}
              value={rest.simples}
              onChange={(e) =>
                onChange(e, () => rest.onChange({ simples: e.target.value }))
              }
              className={invalid && invalid.simples && `invalid`}
            />
            {invalid && invalid.simples && (
              <Error>
                {Messages[invalid.simples] &&
                  Messages[invalid.simples](`Vazio`)}
              </Error>
            )}
          </InputWrapper>
          <InputWrapper flex={0.125}>
            <Label minHeight={`45`}>
              Consumo Super Vazio <Lower>(kWh)</Lower>
            </Label>
            <InputDate
              type={`text`}
              value={rest.svazio}
              onChange={(e) =>
                onChange(e, () => rest.onChange({ svazio: e.target.value }))
              }
              className={invalid && invalid.svazio && `invalid`}
            />
            {invalid && invalid.svazio && (
              <Error>
                {Messages[invalid.svazio] &&
                  Messages[invalid.svazio](`Super Vazio`)}
              </Error>
            )}
          </InputWrapper>
          <InputWrapper flex={0.125}>
            <Label minHeight={`45`}>
              Consumo Cheias <Lower>(kWh)</Lower>
            </Label>
            <InputDate
              type={`text`}
              value={rest.cheias}
              onChange={(e) =>
                onChange(e, () => rest.onChange({ cheias: e.target.value }))
              }
              className={invalid && invalid.cheias && `invalid`}
            />
            {invalid && invalid.cheias && (
              <Error>
                {Messages[invalid.cheias] && Messages[invalid.cheias](`Cheias`)}
              </Error>
            )}
          </InputWrapper>
          <InputWrapper flex={0.125}>
            <Label minHeight={`45`}>
              Consumo Ponta <Lower>(kWh)</Lower>
            </Label>
            <InputDate
              type={`text`}
              value={rest.ponta}
              onChange={(e) =>
                onChange(e, () => rest.onChange({ ponta: e.target.value }))
              }
              className={invalid && invalid.ponta && `invalid`}
            />
            {invalid && invalid.ponta && (
              <Error>
                {Messages[invalid.ponta] && Messages[invalid.ponta](`Cheias`)}
              </Error>
            )}
          </InputWrapper>
        </Multi>
      )
    default:
      return (
        <InputWrapper flex={0.5}>
          <Label>
            Consumo <Lower>(kWh)</Lower>
          </Label>
          <InputDate
            type={`text`}
            value={rest.consumption}
            onChange={(e) =>
              onChange(e, () => rest.onChange({ consumption: e.target.value }))
            }
            className={invalid && invalid.consumption && `invalid`}
          />
          {invalid && invalid.consumption && (
            <Error>
              {Messages[invalid.consumption] &&
                Messages[invalid.consumption](`Consumo`)}
            </Error>
          )}
        </InputWrapper>
      )
  }
}

export default ({ children, nextMonth, ...all }) => (
  <Wrapper>
    <DateMulti>
      <InputWrapper
        className={
          all.invalid &&
          (all.invalid === 'startDateVendDate' ||
            all.invalid === 'datesMustBeBiggerThanTheOthers') &&
          `invalid`
        }>
        <Label minHeight={getMinHeight(all.consumptionDisaggregation)}>
          Data de início
        </Label>
        <DatePicker
          value={all.startDate && moment(all.startDate)}
          placeholder={`Data de início`}
          onChange={({ date }) =>
            all.onChange({
              startDate: (date && date.format('YYYY-MM-DD')) || date,
            })
          }
          initialVisibleMonth={() =>
            all.startDate ? moment(all.startDate) : nextMonth || moment()
          }
        />
        {all.invalid && (
          <Error>
            {Messages[all.invalid] && Messages[all.invalid](`Data de início`)}
          </Error>
        )}
      </InputWrapper>

      <InputWrapper
        className={
          all.invalid &&
          (all.invalid === 'startDateVendDate' ||
            all.invalid === 'datesMustBeBiggerThanTheOthers') &&
          `invalid`
        }>
        <Label minHeight={getMinHeight(all.consumptionDisaggregation)}>
          Data de fim
        </Label>
        <DatePicker
          value={all.endDate && moment(all.endDate)}
          placeholder={`Data de fim`}
          onChange={({ date }) =>
            all.onChange({
              endDate: (date && date.format('YYYY-MM-DD')) || date,
            })
          }
          initialVisibleMonth={() =>
            all.endDate ? moment(all.endDate) : nextMonth || moment()
          }
        />
        {all.invalid && (
          <Error>
            {Messages[all.invalid] && Messages[all.invalid](`Data de fim`)}
          </Error>
        )}
      </InputWrapper>
    </DateMulti>

    {renderExtraInputs(all)}

    <Remove onClick={() => all.onRemove()}>
      <RemoveIcon />
    </Remove>

    {children}
  </Wrapper>
)

const Wrapper = styled.div`
  border: 1px solid #9c9c9c;
  margin: 20px auto;
  display: flex;
  align-items: flex-start;
  max-width: 1024px;
  padding: 20px 10px;

  @media screen and (max-width: 768px) {
    max-width: 90%;
    flex-wrap: wrap;
  }
`

const InputWrapper = styled.div`
  display: block;
  flex: ${({ flex }) => flex || 0.25};
  padding: 0 10px;
  position: relative;
  box-sizing: border-box;

  &.invalid {
    .SingleDatePickerInput {
      border-color: indianred;
    }
  }

  @media (max-width: 767px) {
    flex: 1;
  }
`

const Label = styled.label`
  text-transform: uppercase;
  font-size: 10px;
  font-weight: bold;

  display: block;
  margin-bottom: 8px;
  text-align: left;
  box-sizing: border-box;
  @media (min-width: 767px) {
    ${({ minHeight }) => minHeight && `min-height: ${minHeight}px;`}
  }
`

const InputDate = styled.input`
  display: block;
  width: 100%;
  padding: 10px;
  border: 1px solid #bababa;
  font-size: 16px;
  line-height: 16px;
  letter-spacing: 1px;
  color: #3e3e3e;
  box-sizing: border-box;

  &.invalid {
    border-color: indianred;
  }
`

const Multi = styled.div`
  display: flex;
  flex: 0.5;
  position: relative;

  @media (max-width: 767px) {
    flex: 1;
    align-items: flex-end;
  }

  > div {
    flex: 1;
    width: 100%;
  }
`

const DateMulti = styled(Multi)`
  @media (max-width: 767px) {
    flex-direction: column;
    flex: 1;
    margin-bottom: 8px;
    min-width: 100%;
  }
`

const Remove = styled.button`
  margin-left: auto;
  border: 0;
  background: none;
  outline: none;
  padding: 20px;
  cursor: pointer;

  @media (max-width: 767px) {
    align-self: center;
  }
`

const Lower = styled.span`
  font-size: 10px;
  text-transform: initial;
`

const Error = styled.span`
  display: block;
  font-size: 12px;
  color: indianred;
  margin: 10px auto;
  margin-bottom: 0;
  text-align: left;
`



// WEBPACK FOOTER //
// ./src/components/TableItem/index.js